import api from "../../utils/apiUserCliente";

export const reservarStock = async (items) => {
  const res = await api.post("/api/compras/checkout/reservar", { items });
  return res.data;
};

export const reservaCheckoutDatos = async ({
  grupo_reserva,
  telefono,
  direccion,
  envio,
  pago,
}) => {
  const res = await api.post("/api/compras/checkout/reservar/grupo", {
    grupo_reserva,
    telefono,
    direccion,
    envio,
    pago,
  });
  return res.data;
};

export const obtenerMetodosEnvio = async (grupoReserva) => {
  const res = await api.get(`/api/compras/checkout/metodos-envio/${grupoReserva}`);
  return res.data;
};

export const ObtenerMetodosPago = async (grupoReserva) => {
  const res = await api.get(`/api/compras/checkout/obtener/pagos/${grupoReserva}`);
  return res.data;
};

export const actualizarCheckoutMetodoEnvio = async (payload) => {
  const res = await api.put("/api/compras/checkout/metodo-envio", payload);
  return res.data;
};

export const obtenerResumenCheckoutPago = async (grupoReserva) => {
  const res = await api.get(`/api/compras/checkout/resumen/${grupoReserva}`);
  return res.data;
};

export const confirmarCheckoutPago = async (payload) => {
  let body = payload;
  if (!(payload instanceof FormData)) {
    const fd = new FormData();
    fd.append("grupo_reserva", payload.grupo_reserva);
    fd.append("tienda_metodo_pago_id", String(payload.tienda_metodo_pago_id));
    if (
      payload.tienda_metodo_pago_regla_id != null &&
      payload.tienda_metodo_pago_regla_id !== ""
    ) {
      fd.append(
        "tienda_metodo_pago_regla_id",
        String(payload.tienda_metodo_pago_regla_id)
      );
    }
    if (payload.comprobante_pago instanceof File) {
      fd.append("comprobante_pago", payload.comprobante_pago);
    }
    body = fd;
  }
  const res = await api.post("/api/compras/checkout/confirmar", body);
  return res.data;
};